import { Event, EventName } from '../api/raps/types';

export const rappers: string[] = [
  'Andrew Phang',
  'Andrew Summerton',
  'Campbell Pedersen',
  'Candice Vickers',
  'Christopher Li',
  'Dennis Nguyen',
  'Harry Bird',
  'James Summerton',
  'Leonard Dunne',
  'Lucas Sukadana',
  'Nathan Kosc',
  'Piers Sinclair',
  'Rachel Neumann',
  'Simon Warman',
  'Tristan Hessell',
];

export const events: Event[] = [
  { name: EventName.BSDAC, series: 1 },
  { name: EventName.BSDAC, series: 2 },
  { name: EventName.BSDAC, series: 3 },
  { name: EventName.BSDAC, series: 4 },
  { name: EventName.BSDAC, series: 5 },
  { name: EventName.BSDAC, series: 6 },
  { name: EventName.BSDAC, series: 7 },
  { name: EventName.BSDAC, series: 8 },
  { name: EventName.BSDAC, series: 9 },
  { name: EventName.BSDAC, series: 10 },
  { name: EventName.BSDAC, series: 11 },
  { name: EventName.BSDAC, series: 12 },
  { name: EventName.BSDAC, series: 13 },
  { name: EventName.BEATS, series: 1 },
  { name: EventName.BEATS, series: 2 },
  { name: EventName.BEATS, series: 3 },
  { name: EventName.BEATS, series: 4 },
  { name: EventName.CBB, series: 0 },
];